export default __webpack_public_path__ + "static/media/hotel-resort-img-22.2fdd9171.jpg";